<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Benutzer
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <base-button type="primary" size="sm" v-on:click="$router.push('/users/create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>#</th>
                    <TableHeadFilter :has-filter="true" v-model="tableOptions.filter.customer" title="Orga"
                                     :dropdownList="customers" filter-type="dropdown" @input="changePage(page)"></TableHeadFilter>
                    <TableHeadFilter :has-filter="true" v-model="tableOptions.filter.firstname" title="Vorname"
                                     filter-type="input" @input="changePage(page)"/>
                    <TableHeadFilter :has-filter="true" v-model="tableOptions.filter.lastname" title="Nachname"
                                     filter-type="input" @input="changePage(page)"/>
                    <TableHeadFilter :has-filter="true" v-model="tableOptions.filter.email" title="E-Mail"
                                     filter-type="input" @input="changePage(page)"/>
                    <TableHeadFilter :has-filter="true" v-model="tableOptions.filter.location" title="Standort"
                                     :dropdownList="locations" filter-type="dropdown" @input="changePage(page)"/>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td style="white-space: normal !important;">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ (row.customer) ? row.customer.name : 'fehler?' }}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.firstname}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.lastname}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading" style="white-space: normal !important;"> </div><div v-else>{{row.email}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading" style="white-space: normal !important;"> </div><div v-else>{{ (row.location) ? row.location.name : '-' }}</div>
                    </td>
                    <td class="text-right">
                        <div v-if="isLoading" class="loading-button"> </div><div v-else><base-button v-on:click="$router.push('/users/edit/'+row.id)" icon="fas fa-pencil-alt" type="primary" icon-only
                                                                                                     title="Ansehen und bearbeiten"></base-button></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import TableHeadFilter from "@/components/TableHeadFilter";


    export default {
        name: "list",
        components:{ TableHeadFilter},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tableOptions: {
                    filter: {
                        customer: null,
                        location: null,
                        firstname: null,
                        email: null,
                        lastname: null
                    },
                    sort:{
                    }},
                tableData: [
                    {
                        id: 0,
                        firstname: "",
                        lastname: "",
                        title: 0,
                        email: "",
                        location: {
                            name: null
                        },
                        customer: {
                            name: null
                        }
                    }
                ],
                totalitems: 0,
                page: 1,
                isLoading: false
            }
        },
        created() {
          this.changePage(this.page);
          if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
          if (!this.$store.getters['customer/isReady']) this.$store.dispatch('customer/getCustomerCollection');
          if (!this.$store.getters['location/isReady']) this.$store.dispatch('location/getLocationCollection');
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            customers() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['customer/isReady']) ? [] : this.$store.getters['customer/showCustomerCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            locations() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['location/isReady']) ? [] : this.$store.getters['location/showLocationCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            customerFilterCustomer() {
                return this.tableOptions.customer;
            }
        },
        watch: {
            tableOptions: function () {
                this.changePage(this.page)
            }
        },
        methods: {
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = process.env.VUE_APP_API_SERVER + `/api/users?`+this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,{})+`&page=` + page;

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

